import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AppBar, Toolbar, IconButton, Typography } from "@material-ui/core";
import { Drawer, List, ListItem, ListItemText, Divider } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";

const useStyle = makeStyles((theme) => ({
  root: {},
  menuButton: {
    color: "inherit",
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  buttonGroup: {},
  list: {
    width: 250,
  },
  drawerHeading: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  drawerTitle: {},
}));

function Header() {
  const [drawerToggle, setDrawerToggle] = useState(false);
  const classes = useStyle();

  const toggleHandler = () => {
    setDrawerToggle(!drawerToggle);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <IconButton className={classes.menuButton} onClick={toggleHandler}>
            <MenuIcon />
          </IconButton>
          <Typography className={classes.title} variant="h6">
            Paysable Warehouse
          </Typography>
          <div className={classes.buttonGroup}>
            <IconButton color="inherit" component="a" href="https://www.paysable.com/eng/login/input.jsp">
              <ExitToAppOutlinedIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <Drawer className={classes.drawer} anchor="left" open={drawerToggle} onClose={toggleHandler}>
        <div className={classes.drawerHeading}>
          <Typography className={classes.drawerTitle} variant="subtitle2">
            Back to Paysable
          </Typography>
          <IconButton component="a" href="https://www.paysable.com/eng/">
            <KeyboardReturnIcon />
          </IconButton>
        </div>
        <Divider />
        <List className={classes.list}>
          <ListItem button component="a" href="https://www.paysable.com/eng/transfer/input.jsp">
            <ListItemText primary="Auto Purchase" />
          </ListItem>
          <ListItem button component="a" href="https://www.paysable.com/eng/product/manual.jsp">
            <ListItemText primary="Manual Purchase" />
          </ListItem>
          <ListItem button component="a" href="https://www.paysable.com/eng/product/list.jsp">
            <ListItemText primary="Online Coupon" />
          </ListItem>
          <ListItem button component="a" href="https://www.paysable.com/eng/list/delivery.jsp">
            <ListItemText primary="Delivery" />
          </ListItem>
          <Divider />
          <ListItem button component="a" href="https://www.paysable.com/eng/service/voc.jsp">
            <ListItemText primary="Customer Support" />
          </ListItem>
          <ListItem button component="a" href="https://www.paysable.com/eng/service/faq.jsp">
            <ListItemText primary="FAQ" />
          </ListItem>
          <ListItem button component="a" href="https://www.paysable.com/eng/service/notice.jsp">
            <ListItemText primary="Announcement" />
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
}

export default Header;
